import React, { useEffect, useState } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  getAllUsersOfSuborganizations,
  getSuborganizations
} from '../../../redux/actions/Suborganizations'
import { getSystemDirStorage } from '../../../redux/actions/Storage'
import useStyles from './useStyles'
import { BoxDetails } from './BoxFolderSuborganization/BoxDetails'
import { BoxFolderUsersDetails } from './BoxFolderUsersTable/BoxFolderUsersDetails'
import BreadcrumbsComponent from '../Breadcrumbs/Breadcrumbs'

export const SuborganizationStorageStatus = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [suborganization, setsuborganization] = useState(null)
  const [folder, setfolder] = useState(null)
  const [folderUsers, setfolderUsers] = useState([])

  const handleVerifyState = async () => {
    setLoading(true)
    const suborgResponse = await dispatch(getSuborganizations(id))
    setsuborganization(suborgResponse)
    const verifyDirRoot = await dispatch(
      getSystemDirStorage(suborgResponse.suborganizationId)
    )
    setfolder(verifyDirRoot)
    const staff = await dispatch(getAllUsersOfSuborganizations(id))
    if (staff && staff.length > 0) {
      for (let index = 0; index < staff.length; index++) {
        const user = staff[index]
        const directoryUser = await dispatch(
          getSystemDirStorage(suborgResponse.suborganizationId, user.userId)
        )
        setfolderUsers((folderUsers) => [
          ...folderUsers,
          { user, directoryUser }
        ])
      }
    }
    setLoading(false)
  }

  useEffect(async () => {
    await handleVerifyState()
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <BreadcrumbsComponent
        name={suborganization ? suborganization.suborganizationName : ''}
      />

      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Estado de la inicialización del módulo de almacenamiento
        </Typography>
      </div>
      {suborganization && (
        <>
          <BoxDetails suborganization={suborganization} folder={folder} />
          <BoxFolderUsersDetails folderUsers={folderUsers} loading={loading} />
        </>
      )}
    </div>
  )
}
